import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

import { useOrderPaginate } from "@/hooks/purchases/orders";

import classes from "./ordersFilter.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

const OrdersFilter = ({ filters, applyFilter }) => {
	const { data } = useOrderPaginate(filters);
	const { states, classifications } = data;

	const [defaultUnitFilter, setDefaultUnitFilter] = useState(filters && filters.defaultUnitFilter);
	const [purchaseOrderFilter, setPurchaseOrderFilter] = useState(filters && filters.purchaseOrderFilter);
	const [purchaseClassFilter, setPurchaseClassFilter] = useState(filters && filters.purchaseClassFilter);
	const [purchaseStateFilter, setPurchaseStateFilter] = useState(filters && filters.purchaseStateFilter);
	const [dateFilter, setDateFilter] = useState(filters && filters.dateFilter);
	const [dateToFilter, setDateToFilter] = useState(filters && filters.dateToFilter);

	const handleCleanFilter = () => {
		applyFilter({
			purchaseOrderFilter: "",
			defaultUnitFilter: 1000,
			purchaseClassFilter: "",
			purchaseStateFilter: "",
			dateFilter: "",
			dateToFilter: "",
		});
	};

	const handleApplyFilter = () => {
		applyFilter({
			purchaseOrderFilter,
			defaultUnitFilter,
			purchaseClassFilter,
			purchaseStateFilter,
			dateFilter,
			dateToFilter,
		});
	};

	return (
		<Col md={2} className={classes.filter}>
			<div className={classes.filterTitle}>
				<h4 className={classes.titleH4}>Filtros</h4>
				<hr className={classes.filterHr} />
			</div>

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>N° Orden de Compra</span>
					</Col>
					<Col md={12}>
						<Form.Control
							type="text"
							name="order_code"
							placeholder=" "
							value={purchaseOrderFilter ? purchaseOrderFilter : ""}
							onChange={(e) => setPurchaseOrderFilter(e.target.value)}
						/>
					</Col>
				</Row>

				<hr />

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Unidad de Medida</span>
					</Col>
					<Col md={12}>
						<Select
							value={baseUnits && baseUnits.filter((b) => Number(b.value) === Number(defaultUnitFilter))}
							placeholder={<div>Seleccione</div>}
							options={baseUnits ? baseUnits : []}
							onChange={(value) => setDefaultUnitFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Clasificación</span>
					</Col>
					<Col md={12}>
						<Select
							value={classifications && classifications.filter((b) => Number(b.value) === Number(purchaseClassFilter))}
							placeholder={<div>Seleccione</div>}
							options={classifications ? classifications : []}
							onChange={(value) => setPurchaseClassFilter(value ? value.value : "")}
							components={{ NoOptionsMessage }}
							isClearable
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Estado</span>
					</Col>
					<Col md={12}>
						<Select
							value={states && states.filter((b) => Number(b.value) === Number(purchaseStateFilter))}
							placeholder={<div>Seleccione</div>}
							options={states ? states : []}
							onChange={(value) => setPurchaseStateFilter(value ? value.value : "")}
							isClearable
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default OrdersFilter;
